import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StickyHeader } from '@components/molecules/StickyHeader/StickyHeader';
import { Carousel, CarouselProps } from '@components/molecules/Carousel';
import { BreadcrumbsBanner } from '@components/molecules/BreadcrumbsBanner';
import { ProductsHighlights } from '@components/molecules/ProductsHighlights';
import { PromoBasketsList } from '@components/molecules/PromoBasketsList';
import { MarketplaceAdvertising } from '@components/molecules/MarketplaceAdvertising';
import { Footer } from '@components/molecules/Footer';
import { ProductCardProps } from '@components/molecules/ProductCard';
import { PromoBasketCardProps } from '@components/molecules/PromoBasketCard';
import { Space } from '@components/atoms/Space';
import { MenuPages } from '@types';
import { useData } from '@hooks/useData';

export interface CampaignsProps {
    carouselItems: CarouselProps['items'];
    productsHighlights: ProductCardProps[];
    promoBasketsHighlights: PromoBasketCardProps[];
}

export const Campaigns: FC<CampaignsProps> = ({ carouselItems, productsHighlights, promoBasketsHighlights }) => {
    const { allSettings } = useData();
    const { t } = useTranslation();

    const translations = {
        title: t('campaigns-component.title'),
        productsHighlightsTitle: t('campaigns-component.products-highlights.title'),
        productsHighlightsButton: t('campaigns-component.products-highlights.button'),
        promoBasketsHighlightsTitle: t('campaigns-component.promo-baskets-highlights.title'),
    };

    return (
        <>
            <StickyHeader menuActivePage={MenuPages.Campaigns} />

            <BreadcrumbsBanner
                title={translations.title}
                links={[]}
                currentPage={translations.title}
                image={allSettings?.data?.content_headers_campaigns_image}
            />

            <Space spaceBreakpoints={{ xs: { space: 50 }, md: { space: 100 } }} />

            <Carousel items={carouselItems} mode="boxed" includeLogos={false} />

            <Space spaceBreakpoints={{ xs: { space: 50 }, md: { space: 100 } }} />

            <ProductsHighlights
                title={translations.productsHighlightsTitle}
                actionLabel={translations.productsHighlightsButton}
                linkTo="products"
                products={productsHighlights}
            />

            <Space spaceBreakpoints={{ xs: { space: 50 }, md: { space: 100 } }} />

            {promoBasketsHighlights && promoBasketsHighlights.length > 0 && (
                <PromoBasketsList
                    title={translations.promoBasketsHighlightsTitle}
                    promoBaskets={promoBasketsHighlights}
                    titleAlign="center"
                />
            )}

            <Space spaceBreakpoints={{ xs: { space: 50 }, md: { space: 100 } }} />

            <MarketplaceAdvertising />

            <Footer mode="normal" />
        </>
    );
};
